import { render } from "./Recorrencia.vue?vue&type=template&id=67b06946&scoped=true"
import script from "./Recorrencia.vue?vue&type=script&lang=js"
export * from "./Recorrencia.vue?vue&type=script&lang=js"

import "./Recorrencia.vue?vue&type=style&index=0&id=67b06946&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b06946"]])

export default __exports__